import { BaseInterfaceElement, DOMContainerType, } from '@vendor/libs/maps/interface-elements/base';
import { CustomMap, CustomMapBaseType } from '@vendor/libs/maps/maps';
import { Dropdown } from 'bootstrap';
import { i18n } from '@vendor/libs/lang/lang';
export class LayersAndBaseInterfaceElement extends BaseInterfaceElement {
    constructor(options) {
        super('layers-and-base', options);
        this.visibility = {};
    }
    renderMenu(button) {
        const customMap = this.customMap;
        if (!customMap) {
            return;
        }
        const availableBaseSources = [
            {
                value: CustomMapBaseType.OSM,
                label: 'OSM',
            },
            {
                value: CustomMapBaseType.THUNDERFOREST,
                label: 'Thunderforest',
            },
            {
                value: CustomMapBaseType.GMAPS_HYBRID,
                label: 'Google Hybrid',
            },
        ];
        let availableLayers = [];
        for (const name in customMap.features) {
            const features = customMap.features[name];
            if (features.options.visibilityListed) {
                const available = features.options.visibilityElements ?? [];
                for (const element of available) {
                    if (availableLayers.find((a) => a.name == element.name)) {
                        continue;
                    }
                    availableLayers = [
                        ...availableLayers,
                        {
                            ...element,
                            checked: this.isVisible(features.getVisibilityName()),
                            children: (element.children ?? []).map((child) => ({
                                ...child,
                                checked: this.isVisible(child.name),
                            })),
                        },
                    ];
                }
            }
        }
        button
            .find('ul li')
            .empty()
            .append(`
          <div class="row g-3">
            <div class="col-12">
              <label for="${customMap.selector}_base" class="form-label">
                ${i18n.trans('map.interface_elements.layers_and_base.base')}
              </label>
              
              <select 
                id="${customMap.selector}_base" 
                class="form-select form-select-sm"
              >
                  ${availableBaseSources
            .map((el) => `
                    <option 
                      value="${el.value}" 
                      ${el.value == customMap.currentBaseType ? 'selected' : ''}
                    >
                      ${el.label}
                    </option>
                  `)
            .join('')}
                </select>   
            </div>
            <div class="col-12">
              <label for="${customMap.selector}_base" class="form-label">
                ${i18n.trans('map.interface_elements.layers_and_base.layers')}
              </label>
              
              <div class="row g-1">
              ${availableLayers.length == 0
            ? `<div class="col-12">${i18n.trans('common.empty')}</div>`
            : ''}
                ${availableLayers
            .map((element) => `
                  <div class="col-12">
                    <div class="form-check">
                      <input 
                        data-app-layer_element
                        type="checkbox" 
                        name="${element.name}"
                        class="form-check-input" 
                        id="${customMap.selector}_layer_element_${element.name}"
                        ${element.checked ? 'checked' : ''}
                      />
                      
                      <label 
                        class="form-check-label" 
                        for="${customMap.selector}_layer_element_${element.name}"
                      >
                        ${element.label}
                      </label>
                    </div>
                  </div>
                  
                  ${(element.children ?? [])
            .map((child) => `
                    <div style="${element.checked ? '' : 'display: none'}" class="col-12 ps-4" data-app-element_child_of="${element.name}">
                      <div class="form-check">
                        <input 
                          data-app-layer_element
                          type="checkbox" 
                          name="${child.name}"
                          class="form-check-input" 
                          id="${customMap.selector}_layer_element_${child.name}"
                          ${child.checked ? 'checked' : ''}
                        />
                        
                        <label 
                          class="form-check-label" 
                          for="${customMap.selector}_layer_element_${child.name}"
                        >
                          ${child.label}
                        </label>
                      </div>
                    </div>
                  `)
            .join('')}
                `)
            .join('')}
              </div>
            </div>
          </div>
        `);
    }
    _handle(customMap, id) {
        super._handle(customMap, id);
        const _ = this;
        const button = this.addDOM($(`
        <div class="ol-control position-static dropend" style="border-bottom-left-radius: 0; border-bottom-right-radius: 0">
          <button class="user-select-none" type="button" data-bs-toggle="dropdown" data-bs-auto-close="outside" style="border-bottom-left-radius: 0; border-bottom-right-radius: 0">
            <i class="bx bx-layer"></i>
          </button>
          <ul class="dropdown-menu" style="width: 350px; max-height: 380px; overflow: auto;">
            <li class="px-2">
            </li>
          </ul>
        </div>`), DOMContainerType.MAP_TOP_LEFT);
        new Dropdown(button[0]);
        button.on('change', `#${customMap.selector}_base`, function () {
            let value = $(this).val();
            customMap.changeBase(value);
        });
        button.on('change', `[data-app-layer_element]`, function () {
            _.setVisible($(this).attr('name') ?? '', $(this).is(':checked'));
            if ($(this).is(':checked')) {
                button
                    .find(`[data-app-element_child_of="${$(this).attr('name')}"]`)
                    .show();
            }
            else {
                button
                    .find(`[data-app-element_child_of="${$(this).attr('name')}"]`)
                    .hide();
            }
        });
        button.on('show.bs.dropdown', () => {
            this.renderMenu(button);
        });
        this.visibility = CustomMap.getFromStorage('layers.visibility') ?? {};
    }
    isVisible(name) {
        if (typeof this.visibility[name] == 'undefined' ||
            this.visibility[name] == null) {
            return true;
        }
        return this.visibility[name];
    }
    setVisible(name, state) {
        this.visibility[name] = state;
        CustomMap.saveInStorage('layers.visibility', this.visibility);
        if (this.customMap) {
            for (const n in this.customMap.features) {
                const features = this.customMap.features[n];
                if (name == features.getVisibilityName()) {
                    if (state) {
                        features.show();
                    }
                    else {
                        features.hide();
                    }
                }
                for (const feature of [...features.related, ...features.features]) {
                    feature.changed();
                }
            }
        }
    }
    static setVisibleStatic(mapId, name, state) {
        const map = CustomMap.getMap(mapId);
        if (!map) {
            return;
        }
        const interfaceElement = map.interfaceElements['layers-and-base'] ?? null;
        if (!interfaceElement) {
            return;
        }
        interfaceElement.setVisible(name, state);
    }
}
